<template>
    <div class="projects">
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name:'ProjectsPage',
    props: {
    },
    components: {},
    computed: {},
    mounted() {
    },
}
</script>

<style lang="scss" scoped>
.projects {
    width: 100%;
    height: 100%;
    min-height: 0;
}
</style>
